import React, { useEffect } from 'react';
import {
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  DrawerFooter,
  Flex,
  Text,
  Input,
  Button,
  Box,
  useToast,
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";

export const DefaultDrawerContent = ({
  firstName,
  lastName,
  selectedDate,
  handleFirstNameChange,
  handleLastNameChange,
  handleDateChange,
  handleDateInputFocus,
  dateInputRef,
  handleSearchClick,
  setFirstName,
  setLastName,
  setSelectedDate,
}) => {
  const toast = useToast();


  useEffect(() => {
    const storedFirst = localStorage.getItem("reservationFirstName");
    const storedLast = localStorage.getItem("reservationLastName");
    const storedDate = localStorage.getItem("reservationDate");

    if (storedFirst) setFirstName(storedFirst);
    if (storedLast) setLastName(storedLast);
    if (storedDate) setSelectedDate(new Date(storedDate));
  }, [setFirstName, setLastName, setSelectedDate]);

  const handleLocalSearchClick = () => {
    if (!firstName || !lastName || !selectedDate) {
      toast({
        title: "Missing Information",
        description: "Please enter first name, last name and check in date.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    // Store the date in localStorage
    if (selectedDate) {
      localStorage.setItem("reservationDate", selectedDate.toISOString());
    }

    handleSearchClick();
  };

  return (
    <DrawerContent
      minH={"30vh"}
      borderTopRadius="2xl"
      maxW={{ base: "100%", md: "520px" }}
      mx="auto"
      mb={{ md: 8 }}
      borderRadius={{ md: "24px" }}
    >
      <Flex
        mx={3}
        my={4}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text mr={4} fontSize={"18px"} fontWeight={800}>
          Find Your Booking
        </Text>

        <DrawerCloseButton pos={"relative"} top={0} right={0} />
      </Flex>
      <DrawerBody p={3}>
        <Flex flexDirection={"row"} gap={4}>
          <Flex flexDirection={"column"}>
            <Text fontWeight={800} fontSize={"12px"} pb={"5px"}>
              First Name
            </Text>
            <Input
              bg={"#3e4757"}
              value={firstName}
              onChange={handleFirstNameChange}
            />
          </Flex>
          <Flex flexDirection={"column"}>
            <Text fontWeight={800} fontSize={"12px"} pb={"5px"}>
              Last Name
            </Text>
            <Input
              bg={"#3e4757"}
              value={lastName}
              onChange={handleLastNameChange}
            />
          </Flex>
        </Flex>

        <Text fontWeight={800} fontSize={"11px"} pt={"8px"}>
          * Please use the name of the primary booking guest (Person who made
          the booking in Airbnb, Vrbo etc.)
        </Text>
        <Text fontWeight={800} fontSize={"11px"} pt={"8px"}>
          * Please capitalize your name as it shows when you made your booking
        </Text>
        <Text fontWeight={800} fontSize={"12px"} pb={"5px"} pt={"20px"}>
          Check In Date
        </Text>
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MMMM d, yyyy"
          placeholderText="Select a date"
          className="custom-datepicker"
          onFocus={handleDateInputFocus}
          ref={dateInputRef}
          customInput={
            <Box
              className="custom-datepicker"
              cursor="pointer"
              color="#d0d0d0" // lighter text color
              px="12px"
              py="8px"
              borderRadius="md"
              bg="#3e4757"
              w="200px"
            >
              {selectedDate
                ? new Date(selectedDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "Select a date"}
            </Box>
          }
        />
      </DrawerBody>

      <DrawerFooter p={3}>
        <Button
          onClick={handleLocalSearchClick}
          mb={5}
          bg={"#817efc"}
          color="white"
          h="42px"
          w="full"
          variant="solid"
          borderRadius="10px"
          fontSize="14px"
        >
          Search Booking
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}; 